module.exports = __webpack_public_path__ + "media/SessionStartSoundDramaticAscent.93363895.mp3";